import React, { useEffect, useState } from 'react'
import { Form, Checkbox } from 'antd'
import type { CheckboxChangeEvent } from 'antd/es/checkbox'
import { Controller } from 'react-hook-form'

export interface CheckBoxGroupProps {
  fieldname: string
  isRequired?: boolean
  label?: string
  validate?: any
  validMessage?: any
  className?: string
  control: any
  initValue?: any
  rules?: any
  iProps?: any
  onChangeCheck?: any
  optionsData?: any
}

const SingleCheckbox: React.FunctionComponent<CheckBoxGroupProps> = ({
  fieldname,
  isRequired,
  label,
  validate,
  validMessage,
  className,
  control,
  initValue,
  rules,
  iProps,
  optionsData,
  onChangeCheck,
}: CheckBoxGroupProps) => {
  const [checked, setChecked] = useState(false)

  const onCheckChange = (e: CheckboxChangeEvent) => {
    setChecked(e.target.checked)
  }

  return (
    <Form.Item
      required={isRequired ?? false}
      validateStatus={validate}
      help={validMessage}
      label={label}
      valuePropName="checked"
      className={className}
    >
      <Controller
        rules={rules}
        name={fieldname}
        control={control}
        defaultValue={initValue ?? ''}
        render={({ field: { onChange, value } }) => (
          <Checkbox
            value={value}
            checked={checked}
            {...iProps}
            onChange={(e) => {
              onChange(e)
              onChangeCheck(e)
              onCheckChange(e)
            }}
          >
            {optionsData}
          </Checkbox>
        )}
      />
    </Form.Item>
  )
}

export default SingleCheckbox
